export function getConversationUrl(senderId?: string | null, advisorId?: string | null, origin?: string): string {
  const base = origin || (typeof globalThis !== 'undefined' ? globalThis.location?.origin : '');
  if (!senderId || !advisorId || !base) return (typeof globalThis !== 'undefined' ? globalThis.location.href : '');

  try {
    return `${base}/conversation/${globalThis.btoa(senderId)}/${globalThis.btoa(advisorId)}`;
  } catch (e) {
    // If encoding fails, fall back to current location
    console.log('Error encoding conversation URL:', e);
    return (typeof globalThis !== 'undefined' ? globalThis.location.href : '');
  }
}

export default getConversationUrl;
